export enum KernelLogsMessagesType {
    Boot = "boot",
    All = "all",
}
